// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"589":"b838a90e224cbb34","888":"32dcb88e2daff9be"}[chunkId] + ".css";
};